<template>
  <div class="auth-modal-back" :class="{ opened: opened }" @click="close">
    <span class="helper"></span>
    <div class="popup" @click.stop="noop">
      <div class="content">
        <div class="portions">
          <div class="portion">
            <div class="logo-wrapper">
              <img src="../assets/logoboth.png" alt="" />
            </div>
            <form @submit.prevent="auth" autocomplete="off">
              <div class="auth-form">
                <div class="form-input" v-if="isSigningUp">
                  <div class="user-input">
                    <label>
                      <span :class="{ filled: fullname.length }"> Name </span>
                      <input
                        type="text"
                        v-model.trim="fullname"
                        id="fullname"
                        name="fullname"
                        class="form-control"
                        autocomplete="off"
                        maxlength="50"
                        minlength="2"
                        required
                        placeholder=" "
                        :class="{ filled: fullname.length }"
                      />
                    </label>
                  </div>
                </div>
                <div class="form-input">
                  <div class="user-input">
                    <label>
                      <span :class="{ filled: email.length }"> Email </span>
                      <input
                        type="email"
                        v-model.trim="email"
                        id="email"
                        name="email"
                        class="form-control"
                        autocomplete="off"
                        maxlength="75"
                        required
                        title="Not Valid"
                        placeholder=" "
                        oninvalid="this.setCustomValidity('Not
                  Valid')"
                        oninput="setCustomValidity('')"
                        pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$"
                        :class="{ filled: email.length }"
                      />
                    </label>
                  </div>
                </div>
                <div class="form-input">
                  <div class="user-input">
                    <label>
                      <span :class="{ filled: password.length }">
                        Password
                      </span>
                      <input
                        type="password"
                        v-model="password"
                        id="password"
                        name="password"
                        class="form-control"
                        required
                        placeholder=" "
                        minlength="8"
                        :class="{ filled: password.length }"
                      />
                    </label>
                  </div>
                </div>
                <div class="errors" v-if="error">
                  <p>{{ error }}</p>
                </div>
                <div class="submit-wrapper">
                  <button
                    type="submit"
                    class="btn submit-btn"
                    :disabled="submitButtonDisabled"
                  >
                    {{ submitButtonText }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="portion">
            <div class="have-account-wrapper">
              <p class="have-account">
                {{ swapTextDescription }}
                <a @click="isSigningUp = !isSigningUp" class="login-link"
                  ><span class="login">{{ swapTextAction }} </span></a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus, EventBusEvents } from "../event-bus";

export default {
  name: "AuthModal",
  data() {
    return {
      isSigningUp: true,
      opened: false,
      error: "",
      fullname: "",
      email: "",
      password: "",
      loading: false,
    };
  },
  created() {
    const that = this;
    EventBus.$on(EventBusEvents.OpenSignupModal, function () {
      that.open();
    });
  },
  computed: {
    submitButtonText() {
      if (this.isSigningUp) {
        return this.loading ? "Signing Up..." : "Sign Up";
      } else {
        return this.loading ? "Logging In..." : "Log In";
      }
    },
    submitButtonDisabled() {
      if (this.loading) {
        return true;
      }
      if (this.isSigningUp) {
        return (
          this.fullname.length < 2 ||
          this.email.length < 4 ||
          this.password.length < 8
        );
      } else {
        return this.email.length < 4 || this.password.length < 8;
      }
    },
    swapTextDescription() {
      if (this.isSigningUp) {
        return "Already have an account?";
      } else {
        return "Don't have an account?";
      }
    },
    swapTextAction() {
      if (this.isSigningUp) {
        return "Log In";
      } else {
        return "Sign Up";
      }
    },
  },
  methods: {
    open() {
      this.opened = true;
    },
    close() {
      this.opened = false;
    },
    noop() {},
    auth() {
      if (this.isValidEmail() && this.isValidPassword()) {
        this.loading = true;
        var promise = null;
        if (this.isSigningUp) {
          promise = this.$store.dispatch("auth/register", {
            fullname: this.fullname,
            email: this.email,
            password: this.password,
          });
        } else {
          promise = this.$store.dispatch("auth/login", {
            email: this.email,
            password: this.password,
          });
        }
        promise.then(
          (res) => {
            this.loading = false;
            this.close();
            this.$router.go("/");
          },
          (err) => {
            const message =
              (err.response &&
                err.response.data &&
                err.response.data.message) ||
              err.message ||
              err.toString();
            console.log("Error with auth: " + message);
            this.loading = false;
            if (
              message ===
              "Password must be 8-32 in length, uppercase and lowercase, with at least 1 digit."
            ) {
              this.error = message;
            } else {
              this.error = "There was an error signing up...";
            }
          }
        );
      } else {
        if (this.isValidEmail() && !this.isValidPassword()) {
          this.error = "Your password must be at least 8 chars long";
        } else {
          this.error = "Please enter a valid email.";
        }
      }
    },
    isValidEmail() {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return (
        this.email.length >= 6 && re.test(this.email) && this.email.length <= 75
      );
    },
    isValidPassword() {
      return this.password.length >= 8 && this.password.length <= 50;
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-modal-back {
  background: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  display: none;
  height: 100%;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 10000;
  &.opened {
    display: block;
  }
  .helper {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
  .popup {
    color: black;
    background-color: #fff;
    box-shadow: 10px 10px 60px #555;
    display: inline-block;
    height: auto;
    max-width: 551px;
    min-height: 100px;
    vertical-align: middle;
    width: 92%;
    position: relative;
    border-radius: 8px;
    text-align: left;
    padding: 0;
    flex-grow: 1;
    order: 4;
    @media (min-width: 786px) {
      width: 25%;
    }
  }
}

.logo-wrapper {
  text-align: center;
  img {
    width: 100%;
    margin-bottom: 12px;
  }
}
.content {
  min-height: 100%;
  overflow: hidden;
  margin-bottom: 0;
  flex: 1 1 auto;
  min-width: 0;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-content: stretch;
  .portions {
    justify-content: space-between;
    margin-top: 0;
    max-width: 100%;
    color: #181818;
    flex-grow: 1;
    .portion {
      @media (max-width: 450px) {
        background-color: transparent;
        border: 0;
        align-items: center;
        border-radius: 1px;
        margin: 0 0 10px;
        padding: 13px 0;
        padding-top: 0;
        font-size: 14px;
      }
    }
  }
}
form {
  display: flex;
  flex-direction: column;
  .auth-form {
    margin-top: 8px;
    flex: 0 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    align-content: stretch;
    flex-direction: column;
    .form-input {
      margin: 0 40px 6px;
      align-items: stretch;
      display: flex;
      flex-direction: column;
      .user-input {
        align-items: center;
        background: rgb(250, 250, 250);
        border: 1px solid rgb(219, 219, 219);
        border-radius: 3px;
        color: rgb(38, 38, 38);
        display: flex;
        flex-direction: row;
        font-size: 14px;
        width: 100%;
        label {
          display: flex;
          height: 36px;
          flex: 1 0 0;
          padding: 0;
          position: relative;
          span {
            text-align: left;
            color: rgb(142, 142, 142);
            font-size: 12px;
            height: 36px;
            left: 8px;
            line-height: 36px;
            overflow: hidden;
            pointer-events: none;
            position: absolute;
            right: 0;
            text-overflow: ellipsis;
            transform-origin: left;
            transition: transform ease-out 0.1s;
            user-select: none;
            white-space: nowrap;
            &.filled {
              transform: scale(0.833333) translateY(-12px);
            }
          }
          input {
            font-size: 12px;
            padding: 0 0 2px 8px;
            background: rgb(250, 250, 250);
            border: 0;
            flex: 1 0 auto;
            display: flex;
            overflow: hidden;
            text-overflow: ellipsis;
            color: rgb(38, 38, 38);
            line-height: 18px;
            &.filled {
              padding-top: 14px;
            }
          }
        }
      }
    }
  }
}

.logo-wrapper {
  margin: 22px auto 12px;
  text-align: center;
  img {
    width: 86%;
    margin-bottom: 12px;
  }
}

.login-link {
  color: rgb(0, 149, 246);
  text-decoration: none;
  span {
    display: inline !important;
    margin: 0 !important;
    color: rgb(0, 149, 246);
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
  }
}

.submit-wrapper {
  margin-top: 8px;
  margin-right: 40px;
  margin-left: 40px;
  margin-bottom: 8px;
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  flex-direction: column;
}

.errors {
  font-weight: 600;
  font-size: 14px;
  color: #262626;
  margin: 0 40px 6px;
  margin-top: 8px;
  p {
    margin: 8px;
  }
}
.btn {
  border: 0;
  border-radius: 4px;
  position: relative;
  appearance: none;
  background: 0 0;
  box-sizing: border-box;
  cursor: pointer;
  display: block;
  font-weight: 600;
  padding: 9px 9px;
  text-align: center;
  text-transform: inherit;
  text-overflow: ellipsis;
  user-select: none;
  width: auto;
  font-size: 14px;
  line-height: 18px;
  margin: 0;
  color: #fafafa;
  background-color: #3082c9;
  opacity: 1;
  &:hover {
    opacity: 0.9;
  }
  &:disabled {
    opacity: 0.5;
  }
}
.have-account-wrapper {
  @media (min-width: 768px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .have-account {
    text-align: center;
  }
}
</style>
